import request from "@/router/axios";

export const getList = (params) => {
  return request({
    url: "/api/produce/rtk-sos-alarm/select/page",
    method: "get",
    params,
  });
};

export const handleAlarm = (data) => {
  return request({
    url: "/api/produce/rtk-sos-alarm/handle",
    method: "post",
    data,
  });
};

export const confirmAlarm = (data) => {
  return request({
    url: "/api/produce/rtk-sos-alarm/confirm",
    method: "post",
    data,
  });
};

export const closeAlarm = (data) => {
  return request({
    url: "/api/produce/rtk-sos-alarm/close",
    method: "post",
    data,
  });
};
